export default "__VITE_ASSET__09b2d950__"